import React, { useContext, useEffect } from 'react'

import { NotificationsContext } from '@/hooks/useOnNotification'
import { useTranslation } from 'react-i18next'

import { useGlobalIncidentsQuery } from '@/graphql/generated/hooks'
import {
  IncidentOrderField,
  IncidentStatus,
  OrderDirection,
} from '@/graphql/generated/schemas'
import { startTimer, trackEvent } from '@/utils/analytics'

import { DrawerContainer } from '../../components/DrawerContainer'
import { IncidentsDrawerTitle } from './IncidentsDrawerTitle'
import { IncidentsList } from './IncidentsList'

export const IncidentsDrawer = ({ totalCount }: { totalCount: number }) => {
  const { t } = useTranslation()
  const { data: newData } = useContext(NotificationsContext)
  const {
    data,
    loading: isLoading,
    refetch,
  } = useGlobalIncidentsQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      filter: {
        status: IncidentStatus.Active,
      },
      // Gets the 250 most recent active incidents
      first: 0,
      last: 250,
      orderBy: [
        {
          direction: OrderDirection.Desc,
          field: IncidentOrderField.CreatedAt,
        },
      ],
    },
  })

  useEffect(() => {
    isLoading
      ? startTimer('Page Load: Incident Drawer')
      : trackEvent('Page Load: Incident Drawer', {
          number_of_incidents: totalCount,
        })
  }, [isLoading])

  useEffect(() => {
    if (newData?.notification) {
      refetch()
    }
  }, [newData])
  return (
    <DrawerContainer
      loading={isLoading}
      title={
        <IncidentsDrawerTitle
          title={t('common:notification_active_incidents')}
          totalCount={totalCount}
        />
      }
    >
      <IncidentsList data={data} isLoading={isLoading} />
    </DrawerContainer>
  )
}
